import { createRoute } from '@/utils/routing'

export const TRANSACTIONAL_FEE_LIST_ROUTE = 'fees-index-transactional'
export const TRANSACTIONAL_FEE_VIEW_ROUTE = 'fees-transactional-transactionFeeId'
export const TRANSACTIONAL_FEE_EDIT_ROUTE = 'fees-transactional-transactionFeeId-edit'
export const TRANSACTIONAL_FEE_CREATE_ROUTE = 'fees-transactional-create'

export const RECURRING_FEE_LIST_ROUTE = 'fees-index-recurring'
export const RECURRING_FEE_VIEW_ROUTE = 'fees-recurring-recurringFeeId'
export const RECURRING_FEE_EDIT_ROUTE = 'fees-recurring-recurringFeeId-edit'
export const RECURRING_FEE_CREATE_ROUTE = 'fees-recurring-create'

// function createRouteWithSwiftMessageId (name, swiftMessageId, options) {
//   if (swiftMessageId != null) {
//     return createRoute(name, {
//       params: { ...options.params, swiftMessageId },
//       query: options.query
//     })
//   }
// }

export function createTransactionalFeeListRoute (options = {}) {
  return createRoute(TRANSACTIONAL_FEE_LIST_ROUTE, options)
}

export function createTransactionalFeeViewRoute (transactionFeeId, options = {}) {
  if (transactionFeeId != null) {
    return createRoute(TRANSACTIONAL_FEE_VIEW_ROUTE, {
      params: { ...options.params, transactionFeeId },
      query: options.query
    })
  }
}

export function createTransactionalFeeEditRoute (transactionFeeId, options = {}) {
  if (transactionFeeId != null) {
    return createRoute(TRANSACTIONAL_FEE_EDIT_ROUTE, {
      params: { ...options.params, transactionFeeId },
      query: options.query
    })
  }
}

export function createTransactionalFeeCreateRoute (options = {}) {
  return createRoute(TRANSACTIONAL_FEE_CREATE_ROUTE, options)
}

export function createRecurringFeeListRoute (options = {}) {
  return createRoute(RECURRING_FEE_LIST_ROUTE, options)
}

export function createRecurringFeeViewRoute (recurringFeeId, options = {}) {
  if (recurringFeeId != null) {
    return createRoute(RECURRING_FEE_VIEW_ROUTE, {
      params: { ...options.params, recurringFeeId },
      query: options.query
    })
  }
}

export function createRecurringFeeEditRoute (recurringFeeId, options = {}) {
  if (recurringFeeId != null) {
    return createRoute(RECURRING_FEE_EDIT_ROUTE, {
      params: { ...options.params, recurringFeeId },
      query: options.query
    })
  }
}

export function createRecurringFeeCreateRoute (options = {}) {
  return createRoute(RECURRING_FEE_CREATE_ROUTE, options)
}
